import {Col, UnstyledButton} from '@modifi/ui'
import styled from 'styled-components'

export const Wrapper = styled(Col)`
  display: flex;
  align-items: center;
`

export const TooltipIconWrapper = styled(UnstyledButton)`
  display: flex;
`
